<template>
  <div class="text-center">
    <v-card>
      <v-container>
        <v-row justify="center" class="col-12">
          <v-col cols="12" align="center">
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-row class="col-12">
                <v-col cols="12">
                  <v-autocomplete
                    color="error"
                    label="Zvolte uživatele"
                    v-model="form.userId"
                    :items="users"
                    prepend-icon="mdi-account"
                    item-value="id"
                    hide-selected
                    persistent-hint
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-textarea
                    v-model="form.comment"
                    label="Poznámka"
                    outlined
                    type="text"
                    prepend-icon="mdi-note"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-text-field
                  v-model="form.credit"
                  label="Zadejte počet kreditů"
                  outlined
                  type="number"
                  :rules="[rules.greaterThan(0)]"
                  min="0"
                  prepend-icon="mdi-cash"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="dataChecked"
                    label="Souhlasím s připsáním kreditů uživateli (tato akce nelze vrátit)"
                    :rules="[rules.checked]"
                    required>
                  </v-checkbox>
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn
                    :disabled="!formValid || wait"
                    color="warning"
                    class="mr-4"
                    @click="save"
                  >
                    Připsat kredity
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'AddCreditForm',
  mixins: [rules],
  data () {
    return {
      wait: false,
      dialog: false,
      form: {
        userId: null,
        credit: 0
      },
      users: [],
      dataChecked: false,
      formValid: true
    }
  },
  created () {
    this.$http.get('/admin/roles/6')
      .then(response => {
        this.users = this.keysToCamelCase(response.data)
          .map(user => ({ ...user, text: `${user.firstName} ${user.lastName}, ${user.email}` }))
      })
  },
  methods: {
    save () {
      this.wait = true
      this.$http.post('admin/transactions/add-credit', this.keysToSnakeCase(this.form))
        .then(() => {
          this.wait = false
          this.$emit('data-saved')
        })
    }
  }
}
</script>

<style scoped>

</style>
